import { ConfiguratorStep } from '../types';
import { CONFIGURATOR_DEFAULT_LOCALE } from './locale';

export const CONFIGURATOR_DESIGN_STEP: ConfiguratorStep = {
  id: 'design',
  name: {
    [CONFIGURATOR_DEFAULT_LOCALE]: 'Design',
  },
};

export const CONFIGURATOR_ENGAGEMENT_STEP: ConfiguratorStep = {
  id: 'engagement',
  name: {
    [CONFIGURATOR_DEFAULT_LOCALE]: 'Features',
  },
};

export const CONFIGURATOR_TRAFFIC_STEP: ConfiguratorStep = {
  id: 'traffic',
  name: {
    [CONFIGURATOR_DEFAULT_LOCALE]: 'Marketing',
  },
};

export const CONFIGURATOR_LIVE_STEP: ConfiguratorStep = {
  id: 'live',
  name: {
    [CONFIGURATOR_DEFAULT_LOCALE]: 'Finish',
  },
};

export const CONFIGURATOR_PAYMENT_STEP: ConfiguratorStep = {
  id: 'payment',
  name: {
    [CONFIGURATOR_DEFAULT_LOCALE]: 'Payment',
  },
};

export const CONFIGURATOR_STEPS: ConfiguratorStep[] = [
  CONFIGURATOR_DESIGN_STEP,
  CONFIGURATOR_ENGAGEMENT_STEP,
  CONFIGURATOR_TRAFFIC_STEP,
  CONFIGURATOR_LIVE_STEP,
];

export const CONFIGURATOR_ALL_STEPS: ConfiguratorStep[] = [...CONFIGURATOR_STEPS, CONFIGURATOR_PAYMENT_STEP];

export const CONFIGURATOR_DEFAULT_STEP = CONFIGURATOR_DESIGN_STEP;

export const CONFIGURATOR_VISITED_STEPS_MAP = CONFIGURATOR_STEPS.reduce<Record<string, boolean>>(
  (map, step) => ({
    ...map,
    [step.id]: step.id === CONFIGURATOR_DEFAULT_STEP.id,
  }),
  {},
);
